(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["disklok-language-bar"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.disklokHeaderLanguageEventsBound) return;
    window.disklokHeaderLanguageEventsBound = true;
    const selector = 'details.disklok-header-language';
    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!form.matches('.disklok-header-language__form')) return;
      const returnTo = form.querySelector('[name="return_to"]');
      if (returnTo) {
        returnTo.value = window.location.pathname + window.location.search + window.location.hash;
      }
    }, true);
    document.addEventListener('click', (event) => {
      document.querySelectorAll(selector + '[open]').forEach((details) => {
        if (!details.contains(event.target)) details.open = false;
      });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      document.querySelectorAll(selector + '[open]').forEach((details) => {
        details.open = false;
        details.querySelector('summary').focus();
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
